module.exports = __webpack_public_path__ + "img/2014-1.e7d45bfc.jpeg";